export class LegalEntityAddressInfo {
    id: number | undefined;
	statusId: number | undefined;
	defaultShipping: boolean | undefined;
	defaultBilling: boolean | undefined;
	verified: boolean | undefined;
	addressComplete: boolean | undefined;
	formattedAddress: string | undefined;
    registeredOffice: boolean | undefined;
    commercialOffice: boolean | undefined;
    fiscalOffice: boolean | undefined;
    operativeOffice: boolean | undefined;
    email: string | undefined;
}
